import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map, switchMap, tap } from 'rxjs/operators';
import { NotificationsAdapter } from '../../adapters/notifications.adapter';
import { clearNotifications, loadNotificationsLazy } from '../notifications/notifications.actions';
import {
  loadNotificationSettingsGeneral,
  loadNotificationSettingsGeneralFailure,
  loadNotificationSettingsGeneralSuccess,
  loadNotificationSettingsJobs,
  loadNotificationSettingsJobsFailure,
  loadNotificationSettingsJobsSuccess,
  updateNotificationSettingsGeneral,
  updateNotificationSettingsGeneralFailure,
  updateNotificationSettingsGeneralSuccess,
  updateNotificationSettingsJobs,
  updateNotificationSettingsJobsFailure,
  updateNotificationSettingsJobsSuccess,
} from './notification-settings.actions';

@Injectable()
export class NotificationSettingsEffects {
  private readonly actions$ = inject(Actions);
  private readonly notificationsAdapter = inject(NotificationsAdapter);
  
  loadNotificationSettingsGeneral$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadNotificationSettingsGeneral),
      exhaustMap(() =>
        this.notificationsAdapter.getNotificationSettingsGeneral().pipe(
          map((response) => loadNotificationSettingsGeneralSuccess(response)),
          catchError((error) => {
            return of(loadNotificationSettingsGeneralFailure({ error }));
          })
        )
      )
    )
  );

  loadNotificationSettingsJobs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadNotificationSettingsJobs),
      exhaustMap(() =>
        this.notificationsAdapter.getNotificationSettingsJobs().pipe(
          map((settings) =>
            loadNotificationSettingsJobsSuccess({
              settings,
            })
          ),
          catchError((error) => {
            return of(loadNotificationSettingsJobsFailure({ error }));
          })
        )
      )
    )
  );

  updateNotificationSettingsGeneral$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateNotificationSettingsGeneral),
      switchMap((props) =>
        this.notificationsAdapter.updateNotificationSettingsGeneral(props).pipe(
          map((settings) => updateNotificationSettingsGeneralSuccess(settings)),
          catchError((error) => {
            return of(updateNotificationSettingsGeneralFailure({ error }));
          })
        )
      )
    )
  );

  updateNotificationSettingsJobs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateNotificationSettingsJobs),
      switchMap((props) =>
        this.notificationsAdapter.updateNotificationSettingsJobs(props.settings).pipe(
          map((settings) => updateNotificationSettingsJobsSuccess({ settings })),
          catchError((error) => {
            return of(updateNotificationSettingsJobsFailure({ error }));
          })
        )
      )
    )
  );

  updateNotificationSettingsJobsSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateNotificationSettingsJobsSuccess),
      switchMap(() => [clearNotifications(), loadNotificationsLazy()])
    )
  );

  updateNotificationSettingsGeneralSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateNotificationSettingsGeneralSuccess),
      switchMap(() => [clearNotifications(), loadNotificationsLazy()])
    )
  );

  loadNotificationSettingsGeneralFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(loadNotificationSettingsGeneralFailure),
        tap((action) => {
          // Todo: Add proper error handling. Maybe with a toasty?
          //alert(action.error.message);
        })
      ),
    { dispatch: false }
  );

  loadNotificationSettingsjobsFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(loadNotificationSettingsJobsFailure),
        tap((action) => {
          // Todo: Add proper error handling. Maybe with a toasty?
          //alert(action.error.message);
        })
      ),
    { dispatch: false }
  );
}
